/* eslint-disable */
import React, { Component } from "react";
import "./Dashboard.css";
import axios from "axios";
import config from "./../../config/config.json";
import DataList from "./../../DataList/DataList";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCoffee, faHeart, faRotateRight} from "@fortawesome/free-solid-svg-icons";
import Lottie from "lottie-react";
import IcEmpty from "./../../raw/boat.json";
import ReactGA from "react-ga4";

class Dashboard extends Component {
    constructor(props) {
        super(props);
        this.state = {
            weather: []
        };
    }

    getWeatherData = async (location) => {
        await axios({
            method: "GET",
            url: `${config["BASE_ENDPOINT"]}/api/v1/${location}`
        }).then((res) => {
            if (res.data.data) {
                const { weather } = this.state;
                let jsonData = {};
                if (location === "limone" || location === "campione") {
                    jsonData = res.data.data.jsonData;
                } else {
                    jsonData = res.data.data;
                }

                if (location === "rivadelgarda") {
                    jsonData.location = "VARONE";
                } else {
                    jsonData.location = location.toUpperCase();
                }
                weather.push(jsonData);
                this.setState({ weather });
            }
        });
    };

    async componentDidMount() {
        ReactGA.initialize("G-CFHQM9VNH9");

        // Send a custom event
        ReactGA.event({
            category: "GARDAWIND",
            action: "COMPDIDMOUNT",
            label: "COMPDIDMOUNT-LABEL", // optional
            value: 1, // optional, must be a number
            nonInteraction: true, // optional, true/false
            transport: "xhr", // optional, beacon/xhr/image
        });
        // await this.getWeatherData("rivadelgarda");
        // await this.getWeatherData("torbole");
        // await this.getWeatherData("navene");
        // await this.getWeatherData("limone");
        // await this.getWeatherData("campione");
        // await this.getWeatherData("torri");
        await axios({
            method: "GET",
            url: `${config["BASE_ENDPOINT"]}/api/v1/all`
        }).then((res) => {
            console.log(res)
            if (res.data.data) {
                this.setState({ weather: res.data.data });
            }
        });
    }

    reload = () => {
        window.location.reload()
    }

    render() {
        const { weather } = this.state;
        return (
            <>
                <div className="container txtCenter">
                    <br />
                    <h3>Garda Lake Wind</h3>
                    <h4  onClick={this.reload}><FontAwesomeIcon icon={faRotateRight}/> Aggiorna i dati <span style={{fontSize: "9px"}}>Ultimo agg. {new Date().getHours()}:{new Date().getMinutes().toString().padStart(2, "0")}</span></h4>
                    <p className="txtCenter pBuildWithLove">
                        Build with <FontAwesomeIcon icon={faCoffee} /> and{" "}
                        <FontAwesomeIcon icon={faHeart} /> by{" "}
                        <a href="https://www.chiarani.it">chiarani.it</a>
                    </p>
                    <hr />
                </div>
                {weather.length > 5 ? (
                    <>
                        <DataList weather={weather} />
                        <br />
                        <div className="container txtCenter">
                            <hr />
                            <table className="tbCenter">
                                <tr>
                                    <td>
                                        <a
                                            href="https://www.addicted-sports.com/fileadmin/webcam/torbole/current/816.jpg"
                                            target={"_blank"}
                                            rel="noreferrer">
                                            <img
                                                className="imgWebcam"
                                                src="https://www.addicted-sports.com/fileadmin/webcam/torbole/current/816.jpg"
                                            />{" "}
                                        </a>
                                        <p>Torbole</p>
                                    </td>
                                    <td>
                                        <a
                                            href="https://www.addicted-sports.com/fileadmin/webcam/caporeamol/current/640.jpg"
                                            target={"_blank"}
                                            rel="noreferrer">
                                            <img
                                                className="imgWebcam"
                                                src=" https://www.addicted-sports.com/fileadmin/webcam/caporeamol/current/640.jpg"
                                            />
                                        </a>
                                        <p>Limone</p>
                                    </td>
                                </tr>
                                <tr>
                                    <td>
                                        <a
                                            href="https://www.addicted-sports.com/fileadmin/webcam/campione/current/640.jpg"
                                            target={"_blank"}
                                            rel="noreferrer">
                                            <img
                                                className="imgWebcam"
                                                src="https://www.addicted-sports.com/fileadmin/webcam/campione/current/640.jpg"
                                            />
                                        </a>
                                        <p>Campione</p>
                                    </td>
                                    <td>
                                        <a
                                            href="https://www.addicted-sports.com/fileadmin/webcam/gardasee/current/640.jpg?1563372050"
                                            target={"_blank"}
                                            rel="noreferrer">
                                            <img
                                                className="imgWebcam"
                                                src="https://www.addicted-sports.com/fileadmin/webcam/gardasee/current/640.jpg?1563372050"
                                            />
                                        </a>
                                        <p>Malcesine</p>
                                    </td>
                                </tr>
                                <tr>
                                    <td>
                                        <a
                                            href="https://webcam.tecnodata.it/mirage.gif"
                                            target={"_blank"}
                                            rel="noreferrer">
                                            <img
                                                className="imgWebcam"
                                                src="https://webcam.tecnodata.it/mirage.gif"
                                            />{" "}
                                        </a>
                                        <p>PORTO - PORTO SAN NICOLO</p>
                                    </td>
                                </tr>
                                <tr>
                                    <td colSpan={2}>
                                        <a
                                            href="https://rivadelgarda.panomax.com/porto"
                                            target={"_blank"}
                                            rel="noreferrer">
                                             <iframe src="https://rivadelgarda.panomax.com/porto" ></iframe>
                                            <p>PANORAMAX - PORTO SAN NICOLO</p>
                                        </a>
                                    </td>
                                </tr>


                                <tr>
                                    <td colSpan={2}>
                                        <a
                                            href="https://stream-meteoproject.eu/weathercam-player.php?code=14"
                                            target={"_blank"}
                                            rel="noreferrer">
                                            <iframe
                                                src="https://stream-meteoproject.eu/weathercam-player.php?code=14"
                                                frameBorder="0"></iframe>{" "}
                                            <p>Navene</p>
                                        </a>
                                    </td>
                                </tr>
                                <tr>
                                    <td colSpan={2}>
                                        <a
                                            href="https://ledro.panomax.com"
                                            target={"_blank"}
                                            rel="noreferrer">
                                             <iframe src="https://ledro.panomax.com"></iframe>
                                            <p>Lago di Ledro</p>
                                        </a>
                                    </td>
                                </tr>
                            </table>
                            <table className="tbCenter">
                            <tr>
                                    <td>
                                        <a
                                            href="https://content.meteotrentino.it/dati-meteo/radar/home/mosaicoG.gif"
                                            target={"_blank"}
                                            rel="noreferrer">
                                            <img
                                                className="imgRadar"
                                                src="https://content.meteotrentino.it/dati-meteo/radar/home/mosaicoG.gif"
                                            />{" "}
                                        </a>
                                        <p>Mosaicatura cmax</p>
                                    </td>
                                    <td>
                                        <a
                                            href="https://content.meteotrentino.it/dati-meteo/fulmini/ultima_mappa_lampinet_BIG.png"
                                            target={"_blank"}
                                            rel="noreferrer">
                                            <img
                                                className="imgRadar"
                                                src=" https://content.meteotrentino.it/dati-meteo/fulmini/ultima_mappa_lampinet_BIG.png"
                                            />
                                        </a>
                                        <p>Fultimi (2h) Aeronautica</p>
                                    </td>
                                </tr>

                                <tr>
                                    <td colSpan={2}>
                                        <a
                                            href="https://content.meteotrentino.it/dati-meteo/meteogrammi/cosmo2i_metgram_Riva.png"
                                            target={"_blank"}
                                            rel="noreferrer">
                                            <img
                                                className="imgRadar"
                                                src="https://content.meteotrentino.it/dati-meteo/meteogrammi/cosmo2i_metgram_Riva.png"
                                            />
                                        </a>
                                        <p>Meteogramma Riva</p>
                                        <hr />
                                    </td>

                                </tr>

                                <tr>
                                    <td colSpan={2}>
                                        <a
                                            href="https://content.meteotrentino.it/dati-meteo/meteogrammi/cosmo2i_metgram_MedioGarda.png"
                                            target={"_blank"}
                                            rel="noreferrer">
                                            <img
                                                className="imgRadar"
                                                src="https://content.meteotrentino.it/dati-meteo/meteogrammi/cosmo2i_metgram_MedioGarda.png"
                                            />
                                        </a>
                                        <p>Meteogramma MedioGarda</p>
                                        <hr />
                                    </td>

                                </tr>

                                <tr>
                                    <td colSpan={2}>
                                        <a
                                            href=" https://profiwetter.ch/wind_garda_it.png"
                                            target={"_blank"}
                                            rel="noreferrer">
                                            <img
                                                className="imgRadar"
                                                src=" https://profiwetter.ch/wind_garda_it.png"
                                            />
                                        </a>
                                        <p>Diagramma del Vento</p>
                                    </td>

                                </tr>



                            <tr>
                                <td>
                                    <p></p>
                                <script src="//codice.shinystat.com/cgi-bin/getcod.cgi?USER=SS-44209485-93455"></script>
                        <noscript>
                        <a href="https://www.shinystat.com/it/" target="_top">
                        <img src="//www.shinystat.com/cgi-bin/shinystat.cgi?USER=SS-44209485-93455" alt="Statistiche web" style="border:0px" /></a>
                        </noscript>
                                </td>
                            </tr>
                            </table>
                        </div>




                        <div className="bgFixed">&nbsp;</div>
                    </>
                ) : (
                    <>
                        <Lottie
                            className="animLoadingBuy"
                            autoplay={true}
                            loop={true}
                            animationData={IcEmpty}
                        />
                        <p className="txtCenter pBuildWithLove">Scarico i dati dalle stazioni...</p>
                        <p className="txtCenter pBuildWithLove">Attendi qualche secondo.</p>
                    </>
                )}
            </>
        );
    }
}

export default Dashboard;
